// extracted by mini-css-extract-plugin
export var divider = "_11-0";
export var dividerText = "_11-1";